import { Component, Vue, Inject } from "vue-property-decorator";
import DZServiceDic from '@/views/字典管理/service/DZServiceDic';
import nyMessageToast from "@/utils/NYMessageToast";
import DZModelDic from "@/views/字典管理/model/DZModelDic";
import uploadFile from "@/utils/DZUploadFile";
import DZModelPage from "@/model/DZModelPage";
import DZModelDicType from "@/views/字典管理/model/DZModelDicType";
import ny_config from "@/api/nyConfig";
import api from "@/api/nyApiJson";
import dzMsgBox from "@/utils/DZMessageBox";
@Component({
    components: {}
})
export default class Index extends Vue {

    $refs: any;

    table_height = 0;

    s_dic = new DZServiceDic();
    
    is_dialog_show = false;

    m_page = new DZModelPage(10);

    m_type = new DZModelDicType();

    created() {
        this.m_type.name = this.$route.query.name as string;
        this.m_type.id = this.$route.query.id as string;
        this.s_dic.m_dic.type = this.m_type.id
        this.action_list_data()
    }

    mounted() {
        this.$nextTick(() => {
            const mainHeight = this.$refs.mainContent.offsetHeight;
            console.log("mainHeight", mainHeight)
            const mainScreen = this.$refs.mainScreen.offsetHeight;
            console.log("mainScreen", mainScreen)
            this.table_height = mainHeight - mainScreen - 50;
        })
    }
    action_page_back(){
        this.$router.go(-1)
    }
    action_list_data(){
        this.s_dic.net_page_list_dic(this.m_type.id,this.m_page);
    }

    handle_add(){
        this.is_dialog_show = true
    }

    dialog_close(){
        this.s_dic.m_dic.id = ""
        this.s_dic.m_dic.name = ""
        this.s_dic.m_dic.icon = ""
        this.s_dic.m_dic.imageUrl = ""
        this.is_dialog_show = false
    }

    action_select_file(file) {
        this.s_dic.m_dic.imageUrl = URL.createObjectURL(file.raw);
        if (file.status == "ready") {
            uploadFile.uploadImage(file.raw,
                (res) => {
                }, (res) => {
                    nyMessageToast.success("图片上传成功")
                    this.s_dic.m_dic.icon = res + "";

                }, (res) => {
                    nyMessageToast.error("图片上传失败")
                    this.s_dic.m_dic.icon = "";
                    this.s_dic.m_dic.imageUrl = "";
                });
        }
        this.$forceUpdate()
    }

    handle_submit(){
        if (this.s_dic.m_dic.id && this.s_dic.m_dic.id != '') {
            this.s_dic.net_edit_dic(() => {
                this.action_list_data()
                this.dialog_close()
            });
        } else {
            this.s_dic.net_add_dic(() => {
                this.action_list_data()
                this.dialog_close()
            });
        }
    }

    bindImage(id) {
        if (!id) {
            return "";
        }
        let apiName = "显示图片";
        let apiJson: ny_config = api[apiName];
        let url = apiJson.baseUrl + apiJson.url + "?image=" + id
        console.log(url)
        return url;
    }

    handle_edit(row){
        let obj = Object.assign({},row)
        this.s_dic.m_dic = obj
        this.s_dic.m_dic.imageUrl = this.bindImage(obj.icon)
        this.is_dialog_show = true
    }

    handle_del(id){
        dzMsgBox.del("是否删除该信息？", () => {
            this.s_dic.net_del_dic(id,() => {
                this.action_list_data()
            });
        })
    }
}